import { Action } from '@ngrx/store';
import { AssessmentAnswerInterface } from 'app/assessment/models';
import {
  EmployeeEquipmentWorkflowInterface,
  EmployeeEquipmentWorkflowStatusTypeInterface,
  EquipmentCategoryInterface,
  EquipmentInterface } from 'app/equipment/models';

import { EquipmentActionType } from './equipment-action-type.enum';

export class LoadEquipmentLibrary implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.LoadEquipmentLibrary;
  public readonly payload: any = undefined;
}

export class LoadEquipmentLibraryCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.LoadEquipmentLibraryCompleted;

  constructor(public readonly payload: EquipmentCategoryInterface[]) { }
}

export class LoadEquipmentLibraryFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.LoadEquipmentLibraryFailed;

  constructor(public readonly payload: string) { }
}

export class LoadEquipmentLibraryItem implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.LoadEquipmentLibraryItem;

  constructor(public readonly payload: number) { }
}

export class LoadEquipmentLibraryItemCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.LoadEquipmentLibraryItemCompleted;

  constructor(public readonly payload: EquipmentInterface) { }
}

export class LoadEquipmentLibraryItemFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.LoadEquipmentLibraryItemFailed;

  constructor(public readonly payload: string) { }
}

export class LoadWorkflowStatusTypes implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.LoadWorkflowStatusTypes;
  public readonly payload: any = undefined;
}

export class LoadWorkflowStatusTypesCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.LoadWorkflowStatusTypesCompleted;

  constructor(public readonly payload: EmployeeEquipmentWorkflowStatusTypeInterface[]) { }
}

export class LoadWorkflowStatusTypesFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.LoadWorkflowStatusTypesFailed;

  constructor(public readonly payload: string) { }
}

export class LoadWorkAreas implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.LoadWorkAreas;
  public readonly payload: any = undefined;
}

export class LoadWorkAreasCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.LoadWorkAreasCompleted;

  constructor(public readonly payload: AssessmentAnswerInterface[]) { }
}

export class LoadWorkAreasFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.LoadWorkAreasFailed;

  constructor(public readonly payload: string) { }
}

export class LoadEmployeeEquipmentWorkflows implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.LoadEmployeeEquipmentWorkflows;

  constructor(public readonly payload: number) { }
}

export class LoadEmployeeEquipmentWorkflowsCompleted implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.LoadEmployeeEquipmentWorkflowsCompleted;

  constructor(public readonly payload: EmployeeEquipmentWorkflowInterface[]) { }
}

export class LoadEmployeeEquipmentWorkflowsFailed implements Action {
  public readonly type: EquipmentActionType = EquipmentActionType.LoadEmployeeEquipmentWorkflowsCompleted;

  constructor(public readonly payload: string) { }
}
